module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-sidenav', {
    ref: "layerNav",
    staticClass: "md-left"
  }, [_c('md-toolbar', {
    staticClass: "md-dense main-toolbar"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        return _vm.back()
      }
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Layers")])], 1), _vm._v(" "), _c('layer-list', {
    on: {
      "close": _vm.emitClose
    }
  }), _vm._v(" "), (_vm.validLayers.length > 0) ? _c('layer-picker', {
    attrs: {
      "layers": _vm.showCuesLayers,
      "type": "cue",
      "currentLayer": _vm.currentCueLayer
    }
  }) : _vm._e(), _vm._v(" "), (_vm.validLayers.length > 0) ? _c('layer-picker', {
    attrs: {
      "layers": _vm.showNotesLayers,
      "type": "note",
      "currentLayer": _vm.currentNoteLayer
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEdit) ? _c('layer-new', {
    on: {
      "addLayer": _vm.addLayer
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e0bcef3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layers/nav.vue
// module id = 1229
// module chunks = 21